import Attribute from './Models/Attribute'
import AttributeOption from './Models/AttributeOption'

Vue.prototype.$models.$attribute = new Vue(Attribute)
Vue.prototype.$models.$attributeOption = new Vue(AttributeOption)

Vue.component('attributes-form', () => import(/* webpackChunkName: "attributes-form" */ '@modulesPages/Site/Resources/assets/js/Forms/Attributes/AttributesForm'))
Vue.component('attribute-options-form', () => import(/* webpackChunkName: "attribute-options-form" */ '@modulesPages/Site/Resources/assets/js/Forms/AttributeOptions/AttributeOptionsForm'))

Vue.component('attributes-table', () => import(/* webpackChunkName: "attributes-table" */ '@modulesPages/Site/Resources/assets/js/Tables/AttributesTable'))
Vue.component('attribute-options-table', () => import(/* webpackChunkName: "attribute-options-table" */ '@modulesPages/Site/Resources/assets/js/Tables/AttributeOptionsTable'))

Vue.component('section-collage', () => import(/* webpackChunkName: "section-collage" */ '@modulesPages/Site/Resources/assets/js/Sections/SectionCollage'))
Vue.component('section-services', () => import(/* webpackChunkName: "section-services" */ '@modulesPages/Site/Resources/assets/js/Sections/SectionServices'))
Vue.component('section-secondary-banner', () => import(/* webpackChunkName: "section-secondary-banner" */ '@modulesPages/Site/Resources/assets/js/Sections/SectionSecondaryBanner'))
Vue.component('section-contact', () => import(/* webpackChunkName: "section-contact" */ '@modulesPages/Site/Resources/assets/js/Sections/SectionContact'))
Vue.component('section-products', () => import(/* webpackChunkName: "section-products" */ '@modulesPages/Site/Resources/assets/js/Sections/SectionProducts'))

Vue.component('banner-simple', () => import(/* webpackChunkName: "banner-simple" */ '@modulesPages/Site/Resources/assets/js/Components/BannerSimple'))
Vue.component('title-component', () => import(/* webpackChunkName: "title-component" */ '@modulesPages/Site/Resources/assets/js/Components/TitleComponent'))
Vue.component('message-modal', () => import(/* webpackChunkName: "message-modal" */ '@modulesPages/Site/Resources/assets/js/Components/MessageModal'))
Vue.component('floating-whatsapp', () => import(/* webpackChunkName: "floating-whatsapp" */ '@modulesPages/Site/Resources/assets/js/Components/FloatingWhatsapp'))

Vue.component('card-service', () => import(/* webpackChunkName: "card-service" */ '@modulesPages/Site/Resources/assets/js/Cards/CardService'))
Vue.component('gallery-card', () => import(/* webpackChunkName: "gallery-card" */ '@modulesPages/Site/Resources/assets/js/Cards/GalleryCard'))
Vue.component('card-presentation', () => import(/* webpackChunkName: "card-presentation" */ '@modulesPages/Site/Resources/assets/js/Cards/CardPresentation'))

app.$set(app.$state, 'site', {
    alert: {}
})

app.$Util.formattedStatus = {
	...app.$Util.formattedStatus,
	...{
		'confirmed': 'Confirmado',
	}	
}

app.$set(app.$state, 'gallery', {
	images: [],
	index: null,
	open(index, images) {
		app.$set(app.$state.gallery, 'images', images)
		app.$set(app.$state.gallery, 'index', index)
	}
})
